import { NotificationBanner as Data, NotificationBannerCollection as Collection } from '@/typings/api/NotificationBanner'
import { BaseLkApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'

export class LkNotificationsBannersApi extends BaseLkApiAuth<Data, Collection> {
  protected readonly endpoint = 'notifications/banners';

  public read(
    id: Data['id'],
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = `${id}/viewed`
    const [url] = this.getUrl(path, params)
    return this.request<never, never>('POST', url, { params, ...config })
  }
}
